import MuiLinearProgress, { type LinearProgressProps } from "@mui/material/LinearProgress";
import MuiCircularProgress, { type CircularProgressProps } from "@mui/material/CircularProgress";

export type { LinearProgressProps, CircularProgressProps };

export function LinearProgress(props: LinearProgressProps) {
  return <MuiLinearProgress {...props} />;
}

export function CircularProgress(props: CircularProgressProps) {
  return <MuiCircularProgress {...props} />;
}
